// import React, { useRef, useState } from "react";
import React, { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { AWS_S3_URL } from "utils/constants";
import { HexaGon } from "./Grid";
// import ErrorModal from "components/modal/ErrorModal";
// import AddEventTick from "./AddEventTick";

export default function GridItem({ data }) {
  const [searchParams, setSearchParams] = useSearchParams();
  // const [openErrorModal, setOpenErrorModal] = useState({ open: false });
  const addBtnRef = useRef(null);

  function onClickHanlder(clickEvent) {
    if (addBtnRef.current?.contains(clickEvent.target)) {
      return;
    }

    if (data.type === "club") {
      searchParams.set("club", data.name);
      setSearchParams(searchParams);
    } else {
      searchParams.set("event", data.eventCode);
      setSearchParams(searchParams);
    }
  }

  const onImageLoadError = (e) => {
    if (e) e.target.src = `${AWS_S3_URL}logo22/${data.title.toLowerCase()}.svg`;
  };

  return (
    <HexaGon>
      {data.type === "blank" ? (
        <div className="w-full h-full hex-bg"></div>
      ) : (
        <>
          {/* {openErrorModal.open && (
            <ErrorModal
              closeModal={() => setOpenErrorModal({ open: false })}
              message="Login to register."
              // message={`Registration fee: ${openErrorModal.eventPrice}.\nRegistration begins soon!`}
            />
          )} */}
          <div
            onClick={onClickHanlder}
            className="w-full h-full relative flex items-center justify-center hex_item"
          >
            <div className="absolute w-full h-full top-0 left-0">
              <img
                alt=""
                src={getImageUrl(data)}
                onError={onImageLoadError}
                className="p-4 w-full h-full object-cover drop-shadow-[0_0_0.3rem_#D00B02E6] contrast-125 brightness-200"
              />
            </div>

            {/* {data.isActive && (
              <AddEventTick
                data={data}
                setOpenErrorModal={setOpenErrorModal}
                Ref={addBtnRef}
              />
            )} */}

            <span className="font-bold opacity-75 sm:opacity-100 p-5 hex_item_title">
              {data.title}
            </span>
          </div>
        </>
      )}
    </HexaGon>
  );
}

const getImageUrl = (data) => {
  // if (data.type === "club" && data.image) return data.image;
  if (data.image) return data.image;

  // if (data.type === "event" && data.title)
  //   return `https://edge-results.s3.ap-south-1.amazonaws.com/logo22/${data.title.toLowerCase()}.svg`;

  if (data.type === "event") {
    return `/images/clubs/${data.club}.png`;
  }

  return "/images/clubs/curbrain.png";
};
